import { useState, useEffect } from "react"
import { useContext } from "react"
import { useLocation } from "react-router-dom";
import { Loader, HandCoins } from 'lucide-react';
import { Link } from "react-router-dom";

const Unpaid = (props) => {
  const projects = props.projects;
  const unpaidProjects = projects ? projects.filter(project => project.status === "Complete" && project.paid < project.fee) : [];

  return (
    <div id="unpaidProjects">
      <h3 className="uppercase flex p-0 gap-2 items-center text-[11px] tracking-[0.12em] font-semibold text-[#aaa]">
        <HandCoins color="#ffee00" size={16}/>
        Completed &amp; Unpaid
      </h3>
      <div className="hBar mt-[8px] mb-[12px]"></div>
      {unpaidProjects.length > 0 ? (
        <div className="max-h-[450px] flex flex-col gap-1.5 overflow-y-auto">
          {unpaidProjects.map(project => (
            <Link to="project" state={{ project_id: project.project_id }} key={project.project_id} className="blobLink hoverLeft">
              <div className="flex flex-row gap-2 rounded-lg py-2 px-3 justify-between items-center text-xs blobBG"
                   style={{ borderLeft: '3px solid rgba(255,238,0,0.4)' }}>
                <h4 className="text-[#ddd] font-medium truncate">{project.client} — {project.title}</h4>
                <span className="text-[#555] text-[10px] whitespace-nowrap">{new Date(project.due_date).toLocaleDateString()}</span>
                <span className="text-[#ffb200] font-bold whitespace-nowrap text-[10px]">
                  ${Number(project.fee.replace(/[^0-9.-]+/g,"")) - Number(project.paid.replace(/[^0-9.-]+/g,""))}
                </span>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        projects && projects.length > 0 ? (
          <p className="text-xs text-[#555] tracking-wide">all paid up.</p>
        ) : (
          <Loader className="spinning" />
        )
      )}
    </div>
  )
}


export default Unpaid